var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 31,
    viewBox: "0 0 19 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81288 15.5L17.7336 3.95322C18.1723 3.51328 18.4151 2.92403 18.4096 2.31241C18.4041 1.70079 18.1508 1.11573 17.7043 0.683227C17.2578 0.250729 16.6538 0.00540301 16.0224 8.81815e-05C15.3909 -0.00522665 14.7826 0.229895 14.3284 0.654812L0.705011 13.8508C0.253537 14.2882 -8.7738e-05 14.8815 -8.7738e-05 15.5C-8.7738e-05 16.1185 0.253537 16.7118 0.705011 17.1492L14.3284 30.3452C14.7826 30.7701 15.3909 31.0052 16.0224 30.9999C16.6538 30.9946 17.2578 30.7493 17.7043 30.3168C18.1508 29.8843 18.4041 29.2992 18.4096 28.6876C18.4151 28.076 18.1723 27.4867 17.7336 27.0468L5.81288 15.5Z",
    fill: "#8F8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2ad0d1bc04acfdde86e06b7f0edf6261.svg";
export { ForwardRef as ReactComponent };